(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift_picker_cadeaux"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-gp]');
  if (!root) return;
  var stepCents = parseInt(root.getAttribute('data-step-cents')||'50000',10);
  var colHandle = root.getAttribute('data-col-handle') || '';
  var shouldReload = (root.getAttribute('data-reload')||'true') === 'true';
  var hideIfLocked = (root.getAttribute('data-hide-if-locked')||'false') === 'true';
  var enableRemaining = (root.getAttribute('data-enable-remaining')||'true') === 'true';

  var elWrap   = root;
  var elFill    = root.querySelector('#gp-fill');
  var elSubtotal= root.querySelector('#gp-subtotal');
  var elUnlocked= root.querySelector('#gp-unlocked');
  var elCounters= root.querySelector('#gp-counters');
  var elRemaining= root.querySelector('#gp-remaining');
  var elLimit   = root.querySelector('#gp-limit');
  var refInput  = root.querySelector('#gp-ref');
  var refBtn    = root.querySelector('#gp-ref-add');
  var statusEl  = root.querySelector('#gp-status');

  function setStatus(msg){ if(statusEl){ statusEl.textContent = msg||''; } }

  async function getCart(){
    try{ const r=await fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}}); if(!r.ok) return null; return await r.json(); }catch(e){ return null; }
  }
  function giftCount(cart){
    if(!cart) return 0;
    return (cart.items||[]).filter(i=>{const p=i.properties||{}; return p._gift==='yes'||p['_gift']==='yes';}).reduce((n,i)=>n+i.quantity,0);
  }
  function money(cents){
    return (cents/100).toFixed(2).replace('.', ',') + ' €';
  }
  function progressPercent(subtotal){
    if (subtotal<=0) return 0;
    var rem=subtotal % stepCents;
    if (subtotal < stepCents) return Math.round((subtotal*100)/stepCents);
    return rem===0 ? 100 : Math.round((rem*100)/stepCents);
  }
  function remainingToNext(subtotal){
    if (subtotal<=0) return stepCents;
    var unlocked = Math.floor(subtotal/stepCents);
    var nextThreshold = (unlocked+1)*stepCents;
    var remain = Math.max(0, nextThreshold - subtotal);
    return remain;
  }
  function refreshUI(cart){
    if(!cart) return;
    var subtotal = (cart.items_subtotal_price || 0) * 1;
    var unlocked = Math.floor(subtotal / stepCents);
    var used = giftCount(cart);
    var remaining = Math.max(0, unlocked - used);

    var percent = progressPercent(subtotal);
    if (elFill){ requestAnimationFrame(function(){ elFill.style.width = percent + '%'; }); }
    if (elSubtotal) elSubtotal.textContent = money(subtotal);
    if (elUnlocked) elUnlocked.textContent = String(unlocked);

    var toNext = remainingToNext(subtotal);
    if (elRemaining){
      if (enableRemaining){
        if (toNext>0){
          elRemaining.innerHTML = 'Il ne vous reste plus que <strong>' + money(toNext) + '</strong> avant votre ' + (unlocked>0 ? 'prochain' : 'premier') + ' cadeau.';
        } else {
          elRemaining.textContent = 'Vous avez atteint un palier cadeau.';
        }
      } else {
        elRemaining.textContent = '';
      }
    }

    if (elCounters) elCounters.textContent = 'Utilisés : ' + used + ' — Restants : ' + remaining;

    var limitReached = used >= unlocked && unlocked>0;
    if (elLimit) elLimit.hidden = !limitReached;

    root.querySelectorAll('.gp-add').forEach(function(btn){ btn.disabled = limitReached || unlocked===0; });

    if (hideIfLocked){
      elWrap.classList.toggle('gp-hidden', unlocked===0);
    }
  }

  function normSKU(s){
    return String(s||'').toLowerCase().replace(/[^a-z0-9]/g,'');
  }

  async function addGift(variantId){
    const cart = await getCart();
    if(!cart) return;
    var unlocked = Math.floor((cart.items_subtotal_price||0) / stepCents);
    var used = giftCount(cart);
    if (unlocked===0){ alert('Ajoutez encore des produits pour débloquer votre cadeau.'); return; }
    if (used >= unlocked){ alert('Limite atteinte pour le montant actuel.'); return; }
    var already = (cart.items||[]).some(function(i){
      const p=i.properties||{};
      return (p._gift==='yes'||p['_gift']==='yes') && (i.variant_id===variantId || i.id===variantId);
    });
    if (already){ alert('Ce cadeau est déjà dans votre panier.'); return; }

    const payload = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: { "_gift": "yes" }
      }]
    };
    setStatus('Ajout du cadeau…');
    const r = await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify(payload)
    });
    if (r.ok){
      setStatus('Cadeau ajouté.');
      if (shouldReload){
        setTimeout(function(){ window.location.reload(); }, 200);
      } else {
        setTimeout(updateAll, 150);
      }
    }else{
      try{ const e = await r.json(); setStatus(e.description||'Impossible d’ajouter ce cadeau.'); }catch(_){ setStatus('Impossible d’ajouter ce cadeau.'); }
    }
  }

  async function findVariantIdByRefPredictive(ref){
    const wanted = normSKU(ref);
    const u = new URL('/search/suggest.json', window.location.origin);
    u.searchParams.set('q', ref);
    u.searchParams.set('resources[type]', 'product');
    u.searchParams.set('resources[options][fields]', 'title,variants.sku');
    u.searchParams.set('resources[options][unavailable_products]', 'last');
    u.searchParams.set('resources[options][limit]', '50');
    try{
      const r = await fetch(u.toString(), { headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'} });
      if(!r.ok) return null;
      const j = await r.json();
      const items = (j.resources && j.resources.results && j.resources.results.products) || [];
      for (var i=0;i<items.length;i++){
        const prod = items[i];
        const variants = prod.variants || [];
        for (var k=0;k<variants.length;k++){
          const v = variants[k];
          if (normSKU(v.sku) === wanted){
            return parseInt(v.id,10);
          }
        }
      }
    }catch(_){}
    return null;
  }

  async function findVariantIdByRefFallback(ref){
    if(!colHandle) return null;
    const wanted = normSKU(ref);
    try{
      const r = await fetch(`/collections/${colHandle}/products.json?limit=250`, { headers:{'X-Requested-With':'XMLHttpRequest'} });
      if(!r.ok) return null;
      const j = await r.json();
      const prods = j.products || [];
      for (var i=0;i<prods.length;i++){
        const p = prods[i];
        const variants = p.variants || [];
        for (var k=0;k<variants.length;k++){
          const v = variants[k];
          if (normSKU(v.sku) === wanted){
            return parseInt(v.id,10);
          }
        }
      }
    }catch(_){}
    return null;
  }

  async function addByRef(){
    const ref = (refInput && refInput.value || '').trim();
    if(!ref){ refInput && refInput.focus(); return; }
    setStatus('Recherche « ' + ref + ' »…');
    var vid = await findVariantIdByRefPredictive(ref);
    if(!vid) vid = await findVariantIdByRefFallback(ref);
    if(!vid){ setStatus('Référence introuvable.'); return; }
    setStatus('Référence trouvée.');
    addGift(vid);
  }

  if (refBtn) refBtn.addEventListener('click', addByRef);
  if (refInput) refInput.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); addByRef(); } });

  async function updateAll(){ const c = await getCart(); refreshUI(c); }

  // Stronger refresh hooks
  (function(){
    var origFetch = window.fetch;
    window.fetch = function(){
      var url = arguments[0];
      var p = origFetch.apply(this, arguments);
      try{
        var u = (typeof url === 'string') ? url : (url && url.url) || '';
        if (typeof u === 'string' && /\/cart\/(add|change|update)\.js/.test(u)){
          p.finally(function(){ setTimeout(updateAll, 200); });
        }
      }catch(_){}
      return p;
    };
  })();

  var mo = new MutationObserver(function(){ setTimeout(updateAll, 250); });
  mo.observe(document.body, { childList: true, subtree: true });
  setInterval(updateAll, 8000);

  // Initial wire + first refresh
  updateAll();

  // Wire card buttons after initial render
  root.querySelectorAll('.gp-card').forEach(function(card){
    var vId = card.getAttribute('data-variant-id');
    var btn = card.querySelector('.gp-add');
    if (btn && vId){
      btn.addEventListener('click', function(){ addGift(parseInt(vId,10)); });
    }
  });
})();
// --- Anti-duplication/quantité cadeau ---
// Garde chaque cadeau à qte = 1 et supprime les cadeaux en trop (> cadeaux débloqués)
async function enforceGiftQuantities(){
  const cart = await getCart();
  if(!cart) return;

  var unlocked = Math.floor((cart.items_subtotal_price||0) / stepCents);

  // repère les lignes "cadeau"
  var gifts = [];
  (cart.items||[]).forEach(function(it, idx){
    var p = it.properties || {};
    var isGift = (p._gift==='yes' || p['_gift']==='yes')
                 || /^Cadeau\s+—/i.test(it.product_title)  // ceinture+bretelles
                 || (it.product_title && it.product_title.toLowerCase().includes('cadeau'));
    if (isGift) gifts.push({ index: idx+1, qty: it.quantity });
  });

  // construit les corrections
  var changes = {};
  // 1) chaque cadeau doit rester à 1
  gifts.forEach(function(g){ if (g.qty !== 1) changes[g.index] = 1; });
  // 2) si + de cadeaux que débloqués, supprime les extras
  if (gifts.length > unlocked){
    gifts.slice(unlocked).forEach(function(g){ changes[g.index] = 0; });
  }

  if (Object.keys(changes).length){
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({ changes })
    });
    setTimeout(updateAll, 200);
  }
}

// Appels automatiques de sécurité
// - après chaque refresh UI
var _oldRefreshUI = refreshUI;
refreshUI = function(cart){
  _oldRefreshUI(cart);
  enforceGiftQuantities();
};

// - après toute requête cart add/change/update
(function(){
  var origFetch = window.fetch;
  window.fetch = function(){
    var url = arguments[0];
    var p = origFetch.apply(this, arguments);
    try{
      var u = (typeof url === 'string') ? url : (url && url.url) || '';
      if (typeof u === 'string' && /\/cart\/(add|change|update)\.js/.test(u)){
        p.finally(function(){ setTimeout(enforceGiftQuantities, 150); });
      }
    }catch(_){}
    return p;
  };
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
